import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { first } from 'rxjs/operators';

import { RegistroVentasService } from '../../registro/Services/registro-ventas.service';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import Swal from 'sweetalert2';
import { CustomValidators } from '../../utilities/custom-validators';

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.css']
})
export class RestorePasswordComponent implements OnInit {

  @ViewChild('stepper') stepper;

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  email= "";
  token= 0;
  mailvalidate= false;

  Token = {
    usuarioTokenId: 0,
    codigo: 0,
    validoHasta: "",
    validado: false,
    email: ""
  }
  constructor(
    private _formBuilder: FormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private registroService: RegistroVentasService,
      
  ) { }

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      email: [null, [Validators.required, Validators.email]],

    });
    this.secondFormGroup = this._formBuilder.group({
      token: [null, [Validators.required, Validators.pattern("^[0-9]*$")]]
    });
    this.thirdFormGroup = this._formBuilder.group({
      newPassword: [null, Validators.required],
      repetPassword: [null, Validators.compose([Validators.required])]
    },{
      // check whether our password and confirm password match
      validator: CustomValidators.passwordMatchValidator.bind(this)
   });
  }
  onValidateCode(){
    if(this.secondFormGroup.controls['token'].value == this.Token.codigo)
    {
      this.stepper.next();
    }else{
      Swal.fire({
        icon: 'error',
        title: 'Codigo errado.',
        text: 'El código ingresado no coincide, favor verifiquelo nuevamente.'
      })
      
      this.secondFormGroup.controls['token'].setValue("");
    }
  }
  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    const password = group.get('password').value;
    const confirmPassword = group.get('confirmPassword').value;
  
    return password === confirmPassword ? null : { notSame: true }     
  }
  onCambiarContrasena(){
    this.registroService.cambioContrasena(this.thirdFormGroup.controls['newPassword'].value,this.Token).subscribe(
      resolve => {
        if (resolve != null) {
          if(resolve.success)
          {
            Swal.fire({
              icon: 'success',
              title: 'Confirmado',
              showConfirmButton: false,
              text: 'La contraseña se ha cambiado exitosamente' 
            });
            this.router.navigate(['/login']);
          }else{
            Swal.fire({
              icon: 'error',
              title: 'Error...',
              text: resolve.message
            });
          }
        }else{
          Swal.fire({
            icon: 'error',
            title: 'Error...',
            text: 'Ocurrio un error intentando consultar los datos'
          })
        }
      }
    );
  }
  onValidateMail() {
    // Validate your value in the function
    
    if (this.firstFormGroup.controls['email'].value != "") {

      this.registroService.generarTokenCambioContrasena(this.firstFormGroup.controls['email'].value).subscribe(
        resolve => {

          if (resolve != null) {
            
            if(resolve.success)
            {
              this.Token.usuarioTokenId = resolve.result.usuarioTokenId;
              this.Token.codigo = resolve.result.codigo;
              this.Token.validoHasta = resolve.result.validoHasta;
              this.Token.validado = resolve.result.validado;
              this.Token.email = resolve.result.email;
              this.stepper.next();
            }else{
              Swal.fire({
                icon: 'error',
                title: 'Error...',
                text: resolve.message
              });
              
              this.firstFormGroup.controls['email'].setValue("");
            }
  
          }
          else
          {
            Swal.fire({
              icon: 'error',
              title: 'Error...',
              text: 'Ocurrio un error intentando consultar los datos'
            })
            
            this.firstFormGroup.controls['email'].setValue("");
          }
  
        },
        (error: ErrorResponse) => {
          
          this.firstFormGroup.controls['email'].setValue("");
        }
      );
      this.mailvalidate = true;
    }
  }
  
}
